export const getTenantFromSubdomain = (): string | null => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  // Check if it's a subdomain (more than 2 parts for domain.com or more than 1 for localhost)
  if (hostname.includes('localhost')) {
    const subdomain = parts[0];
    const result = subdomain !== 'localhost' ? subdomain : null;
    return result;
  }

  // For production domains like tenant.easyidentity.ai
  if (parts.length > 2) {
    const result = parts[0];
    return result;
  }
  return null;
};

export const isValidTenant = (tenant: string): boolean => {
  // Add your tenant validation logic here
  // For now, just check if it's not empty and alphanumeric with possible hyphens
  const isValid = /^[a-zA-Z0-9-]+$/.test(tenant) && tenant.length > 0;
  return isValid;
};
